import { useEffect, useReducer } from "react";

import Main from "./Main";
import Header from "./Header";
import Error from "./Error";
import Loader from "./Loader";
import StartPage from "./StartPage";
import FinishPage from "./FinishPage";
import Question from "./Question";
import Footer from "./Footer";
import Button from "./Button";
import SummaryHeader from "./SummaryHeader";

const initialState = {
  questions: [],
  index: 0,
  sumPoints: 0,
  answer: null,
  status: "loading",
  remainingSeconds: 600,
};

function reducer(state, action) {
  switch (action.type) {
    case "loading":
      return { ...state };
    case "error":
      return { ...state, status: "error" };
    case "dataReceived":
      return {
        ...state,
        questions: action.payload.questions,
        status: action.payload.status,
      };
    case "start":
      return {
        ...state,
        status: "next",
      };
    case "answerQuestion":
      return {
        ...state,
        answer: action.payload.answer,
        sumPoints: state.sumPoints + action.payload.point,
      };
    case "next":
      return { ...state, index: state.index + 1, answer: null };
    case "finish":
      return {
        ...state,
        status: "result",
      };
    case "timerTick":
      return {
        ...state,
        status: state.remainingSeconds > 0 ? state.status : "result",
        remainingSeconds: state.remainingSeconds - 1,
      };
    case "restart":
      return {
        ...initialState,
        status: "ready",
        questions: state.questions,
      };
    default:
      throw new Error("Failed to fetch questions...");
  }
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const maxPossiblePoints = state.questions.reduce(
    (acc, cur) => acc + cur.points,
    0
  );

  const min = Math.floor(state.remainingSeconds / 60);
  const second = state.remainingSeconds % 60;

  useEffect(function () {
    async function fetchQuestions(url) {
      const response = await fetch(url);
      if (response.ok === true) {
        const questions = await response.json();

        return questions;
      }

      throw new Error("There was problem with fetching questions!");
    }
    fetchQuestions("data/questions.json")
      .then((res) => {
        return res;
      })
      .then((data) => {
        dispatch({
          type: "dataReceived",
          payload: { status: "ready", questions: data.questions },
        });
      })
      .catch((err) => {
        dispatch({ type: "error" });
      });
  }, []);

  const numQuestions = state.questions.length;

  return (
    <div className="app">
      <Header
        index={state.index}
        numQuestions={numQuestions}
        sumPoints={state.sumPoints}
      />
      <Main>
        {state.status === "loading" && <Loader />}
        {state.status === "error" && <Error />}
        {state.status === "ready" && (
          <StartPage dispatch={dispatch} numQuestions={numQuestions} />
        )}
        {state.status === "next" && (
          <>
            <SummaryHeader
              index={state.index}
              numQuestions={numQuestions}
              sumPoints={state.sumPoints}
              answer={state.answer}
              maxPossiblePoints={maxPossiblePoints}
            />
            <Question
              question={state.questions.at(state.index)}
              answer={state.answer}
              index={state.index}
              dispatch={dispatch}
              numQuestions={numQuestions}
              remainingSeconds={state.remainingSeconds}
            />
            <Footer>
              <div className="timer">
                <span>
                  {min < 10 ? `0${min}` : min} :
                  {second < 10 ? `0${second}` : second}
                </span>
              </div>
              <Button
                index={state.index}
                numQuestions={numQuestions}
                dispatch={dispatch}
                answer={state.answer}
              />
            </Footer>
          </>
        )}
        {state.status === "result" && (
          <FinishPage
            dispatch={dispatch}
            sumPoints={state.sumPoints}
            maxPossiblePoints={maxPossiblePoints}
          />
        )}
      </Main>
    </div>
  );
}

export default App;
